import { type Epic, combineEpics } from 'redux-observable';
import { filter, mergeMap } from 'rxjs';
import { request } from '@/core';
import { openSnackbar } from '@/core/features/snackbar';
import { deleteMemberRequest } from '@/api/members';
import i18n from '@/i18n';
import { fetchMembers, deleteMember } from '../actions';

const deleteMemberEpic: Epic = (action$) =>
  action$.pipe(
    filter(deleteMember.match),
    request(({ payload }) => deleteMemberRequest(payload), deleteMember),
  );

const deleteMemberSucceededEpic: Epic = (action$) =>
  action$.pipe(
    filter(deleteMember.succeeded.match),
    mergeMap(
      ({
        payload: {
          originalData: { propertyId },
        },
      }) => [
        openSnackbar({
          snackbarType: 'success',
          snackbarMessage: i18n.t('DELETE_MEMBER_SUCCESS'),
        }),
        fetchMembers({ propertyId }),
      ],
    ),
  );

export default combineEpics(deleteMemberEpic, deleteMemberSucceededEpic);
